/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogDatetime } from "../../d-dialog-datetime";
import { DThemeWhiteDialogFitted } from "./d-theme-white-dialog-fitted";

export class DThemeWhiteDialogDatetime
	extends DThemeWhiteDialogFitted
	implements DThemeDialogDatetime {}
